export enum SubscriptionTimeInForce {
  Immediate = 1,
  BeginningOfNextMonth = 2,
}
